export const MemberIdTypeConstants = {
    OTHER: 'aaca7a4c-49dc-4e50-8be6-62720ae79a69',
    SOUTH_AFRICAN_CITIZEN: '35a076b5-e287-430a-b3df-9f7cad5798cb',
};
